import styles from './NoelSolidaireHeader.module.css'

// Le visuel est porté par le CSS (paysage ou version mobile selon la largeur
// de l'en-tête) : seule l'image affichée est téléchargée.
const NoelSolidaireHeader = () => (
  <header className={styles.header}>
    <div
      className={styles.visual}
      role="img"
      aria-label="Noël Solidaire – Dîner de Noël ou panier gourmand à emporter, le 24 décembre à l'Hôtel de Ville à partir de 19h. Devenez bénévole pour cette journée de Noël. Ville de Montpellier."
    />
  </header>
)

export default NoelSolidaireHeader
